import PropTypes       from 'prop-types'
import { columnsType } from 'utils/type-utils'
import TableRow        from 'components/table/TableRow'
import Loader          from 'components/common/Loader';
import {
  Box,
  TableBody,
  TableCell,
  TableRow as MuiTableRow
} from '@mui/material';

const TableRows = ({rows, columns, loading, section, ...rest}) => (
  <TableBody>
    {rows.map((row, index) => <TableRow key={index} row={row} columns={columns} section={section} index={index} rowAction={rest.rowAction}/>)} 
    {loading ? <LoadingTableRow columns={columns} /> : null}
  </TableBody>
)

const LoadingTableRow = ({columns}) => (
  <MuiTableRow>
    <TableCell colSpan={columns.length} style={{textAlign: "center", paddingLeft: '4px', paddingRight: '4px'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent:'center'}}>
        <Loader size='micro'/>
      </Box>
    </TableCell>
  </MuiTableRow>
)

const rowType = PropTypes.shape({
  onClick: PropTypes.func,
  cells  : PropTypes.object.isRequired
}).isRequired

const rowsType = PropTypes.arrayOf(rowType).isRequired

TableRows.propTypes = {
	rows    : rowsType,
  columns: columnsType
}

export default TableRows;